module.exports = __webpack_public_path__ + "img/logo.d5833cb5.png";